import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    tableLayout: 'fixed',
  },
  tableRow: {
    '& td': {
      padding: theme.spacing(1, 2),
    },
  },
  nameCellWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  expandButton: {
    padding: theme.spacing(0.5),
    flexShrink: 0,
  },
  expandSpacer: {
    width: 28,
    flexShrink: 0,
  },
  nestedName: {
    paddingLeft: theme.spacing(0.5),
  },
  nameColumn: {
    width: '35%',
    minWidth: 240,
  },
  auditDateColumn: {
    minWidth: 110,
  },
  actionsColumn: {
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
  },
  nameCell: {
    cursor: 'pointer',
    verticalAlign: 'baseline',
    textAlign: 'left',
    border: 0,
    padding: 0,
    background: 'none',
    font: 'inherit',
    wordBreak: 'break-word',
  },
  nameCellDownloading: {
    opacity: 0.6,
    pointerEvents: 'none',
  },
  nameCellDownloadingLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  statusText: {
    fontWeight: 500,
  },
  statusInProgress: {
    color: theme.palette.warning.main,
  },
  statusCompleted: {
    color: theme.palette.success.main,
  },
  statusPendingCorrection: {
    color: theme.palette.grey['500'],
  },
  statusSentToContractor: {
    color: theme.palette.info.main,
  },
  actionsCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.25),
    flexWrap: 'nowrap',
  },
  iconButton: {
    padding: theme.spacing(0.75),
  },
  emptyText: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(2),
    textAlign: 'center',
  },
}));

export default useStyles;
